import React, { Component } from 'react';
import { timeZoneOptions } from 'lib/TimeZones';
import HForm, {
  TextField,
  PlainSelectField,
  SelectField,
} from 'shared/containers/portal_layout/HForm';
import Errors from 'shared/components/Errors';
import SpinnerButton from 'shared/components/SpinnerButton';
import LoadingContent from 'shared/components/LoadingContent';
import api from 'utils/api';

class MyInfo extends Component {
  constructor() {
    super();
    this.state = { specialties: null };
  }

  componentDidMount() {
    this.fetchSpecialties();
  }

  fetchSpecialties() {
    api.get(`/shared/api/standard_specialties`).then(response => {
      this.setState({ specialties: response.data });
    });
  }

  render() {
    if (!this.state.specialties) return <LoadingContent />;
    return <PresentationComponent {...this.props} specialties={this.state.specialties} />;
  }
}

const PresentationComponent = props => (
  <HForm onSubmit={props.handleSubmit}>
    <Errors errors={props.error || []} />
    <TextField name="firstName" label="First Name" />
    <TextField name="lastName" label="Last Name" />
    <TextField name="email" label="Email" />
    <PlainSelectField name="timeZoneName" label="Timezone" options={timeZoneOptions} />
    {props.currentAgent.specialtyIds && (
      <SelectField
        name="specialtyIds"
        label="Specialties"
        placeholder="Type your specialty names..."
        options={props.specialties}
        valueKey="id"
        labelKey="name"
        multi
        className="input-xxlarge"
        simpleValue="simpleArray"
      />
    )}
    <div className="form-actions">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        Update Info
      </SpinnerButton>
    </div>
  </HForm>
);

export default MyInfo;
